var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_11921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1021 35.855C73.9554 35.6541 70.4296 30.875 64.166 26.0592C55.8229 19.6457 46.555 16.2539 37.3636 16.2539C28.1722 16.2539 18.9393 19.652 10.6744 26.08C4.46972 30.9069 1.00461 35.6971 0.859501 35.8996L0 37.0988L0.940827 38.2358C1.10986 38.4399 5.15382 43.2923 11.6168 48.2006C20.2772 54.7752 29.1656 58.2499 37.3237 58.2499C45.4818 58.2499 54.4196 54.772 63.1853 48.191C69.728 43.2795 73.8485 38.4239 74.0207 38.2198L74.9903 37.0701L74.1037 35.8566L74.1021 35.855ZM37.3237 42.5396C34.2604 42.5396 31.768 40.0473 31.768 36.984C31.768 33.9207 34.2604 31.4283 37.3237 31.4283C40.387 31.4283 42.8794 33.9207 42.8794 36.984C42.8794 40.0473 40.387 42.5396 37.3237 42.5396ZM35.4102 22.2608V27.7974C31.7696 28.5548 28.8945 31.4299 28.1371 35.0704H22.6006C23.4617 28.4113 28.751 23.1219 35.4102 22.2608ZM28.1371 38.8975C28.8945 42.5396 31.768 45.4132 35.4102 46.1706V51.7071C28.751 50.846 23.4617 45.5567 22.6006 38.8975H28.1371ZM39.2373 46.1706C42.8794 45.4132 45.7529 42.5396 46.5103 38.8975H52.0468C51.1858 45.5567 45.8964 50.846 39.2373 51.7071V46.1706ZM46.5103 35.0704C45.7529 31.4299 42.8794 28.5548 39.2373 27.7974V22.2608C45.8964 23.1219 51.1858 28.4113 52.0468 35.0704H46.5103ZM4.90665 36.9425C7.46921 33.849 15.1601 25.5298 26.383 21.8622C21.7012 25.2587 18.6507 30.7713 18.6507 36.9856C18.6507 43.1998 21.8942 49.0553 26.8247 52.4199C21.8001 50.5733 17.3527 47.7413 14.0008 45.2043C9.68573 41.9369 6.45662 38.6328 4.90665 36.9441V36.9425ZM47.7605 52.4614C52.7262 49.1015 55.9967 43.4183 55.9967 36.984C55.9967 30.5497 52.9127 25.1965 48.1863 21.8048C53.7659 23.586 58.3918 26.4595 61.7421 29.0236C65.7893 32.1204 68.6516 35.2538 70.0469 36.9106C67.1352 40.0233 58.4588 48.5817 47.7605 52.4614Z",
    fill: "#06164C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4013 0H35.5742V9.55019H39.4013V0Z",
    fill: "#01C38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0206 2.09267L19.6484 3.90234L24.205 12.3933L27.5772 10.5836L23.0206 2.09267Z",
    fill: "#01C38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6909 2.09192L47.1328 10.582L50.5047 12.3923L55.0628 3.90218L51.6909 2.09192Z",
    fill: "#01C38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2372 64.4648H35.4102V73.9991H39.2372V64.4648Z",
    fill: "#01C38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1976 61.6442L19.6328 70.1289L23.0031 71.9421L27.5679 63.4574L24.1976 61.6442Z",
    fill: "#01C38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5142 61.6466L47.1445 63.4609L51.713 71.9455L55.0827 70.1311L50.5142 61.6466Z",
    fill: "#01C38E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_11921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.9903,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.d0aceb00f6df31cfb4bf58432228f53e.svg";
export { ForwardRef as ReactComponent };